import {Divider as MUIDivider, DividerProps, styled} from '@mui/material';

const Divider = styled(MUIDivider)<any>((props: DividerProps) => ({
  margin: '10px 0',
}));
export default Divider;
